import { motion } from "framer-motion";
import { Linkedin } from "lucide-react";

const FOUNDER_PHOTO = "https://customer-assets.emergentagent.com/job_bharatintelli-engage/artifacts/j4tx3e11_file_00000000ae54720786c5d2b8ec0361d3.png";

const milestones = [
  { label: "Bachelor of Engineering from BIT Mesra" },
  { label: "Full-Time MBA from University of Leeds, UK" },
  { label: "Diploma in Management Consultancy, Institute of Business Consulting, UK" },
  { label: "20+ Years Global Experience" },
  { label: "Data, Analytics & AI Leadership" },
  { label: "Mumbai, Pune, Bengaluru, London" },
];

const companies = ["Shell", "BT", "Telstra", "Tata"];

export default function Founder() {
  return (
    <section id="founder" data-testid="founder-section" className="py-24 md:py-32 relative warm-section-alt">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          <motion.div initial={{ opacity: 0, x: -30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} className="relative">
            <div className="rounded-2xl overflow-hidden border border-[#ebe5dc] aspect-[3/4] max-w-sm mx-auto lg:mx-0 bg-white">
              <img src={FOUNDER_PHOTO} alt="Rewat Raj - Founder" className="w-full h-full object-cover object-top" data-testid="founder-photo" />
            </div>
            <div className="absolute -bottom-3 -left-3 bg-white border border-[#ebe5dc] rounded-2xl px-5 py-3 shadow-sm">
              <p className="text-2xl font-bold text-[#2a9d8f]" style={{ fontFamily: 'Fraunces, serif' }}>20+</p>
              <p className="text-xs text-[#8a8078]">Years of Impact</p>
            </div>
          </motion.div>
          <motion.div initial={{ opacity: 0, x: 30 }} whileInView={{ opacity: 1, x: 0 }} viewport={{ once: true }} transition={{ delay: 0.2 }}>
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2a9d8f] mb-4">Meet the Founder</p>
            <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#2d2926] mb-2" style={{ fontFamily: 'Fraunces, serif' }}>Rewat Raj</h2>
            <p className="text-lg text-[#5c564e] mb-2">Founder & CEO, BharatIntelliAI</p>
            <p className="text-sm text-[#2a9d8f] font-medium mb-6">Global experience, local delivery.</p>

            <p className="text-base text-[#5c564e] leading-relaxed mb-4">
              With over two decades of global experience driving digital transformation, product management, and enterprise growth across telecom, supply chain, sales, and marketing — Rewat specializes in bridging business strategy with cutting-edge technology. Based in London-trained, India-delivered.
            </p>
            <p className="text-base text-[#5c564e] leading-relaxed mb-8">
              From leading multimillion-dollar transformations for global enterprises to delivering measurable revenue growth, operational excellence, and strategic market expansion — he brings a proven track record of turning complex business challenges into impactful outcomes.
            </p>

            <div className="flex flex-wrap gap-2 mb-6">
              {milestones.map((m) => (
                <span key={m.label} className="px-3 py-1.5 rounded-full text-xs font-medium text-[#5c564e] border border-[#ebe5dc] bg-white">{m.label}</span>
              ))}
            </div>

            <div className="mb-8 p-4 rounded-2xl border border-[#ebe5dc] bg-white">
              <p className="text-[10px] font-bold uppercase tracking-[0.15em] text-[#8a8078] mb-3">Companies Worked With</p>
              <div className="flex flex-wrap gap-3">
                {companies.map((c) => <span key={c} className="px-4 py-2 rounded-xl text-sm font-semibold text-[#2d2926] bg-[#f5f0e8] border border-[#ebe5dc]" data-testid={`company-${c.toLowerCase()}`}>{c}</span>)}
              </div>
            </div>

            <a href="http://www.linkedin.com/in/rewatraj" target="_blank" rel="noopener noreferrer" data-testid="founder-linkedin-link"
              className="inline-flex items-center gap-2 text-[#2a9d8f] hover:text-[#238b7f] font-medium text-sm transition-colors">
              <Linkedin size={18} /> Connect on LinkedIn
            </a>
          </motion.div>
        </div>
      </div>
    </section>
  );
}
